<script setup lang="ts">
const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  hideDetails = undefined,
  label = '',
  placeholder = '',
  rounded = 'lg',
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  hideDetails?: boolean | 'auto';
  label?: string;
  rounded?: string | number | boolean;
  placeholder?: string;
}>();

const text = defineModel<string | number | null>();
</script>
<template>
  <v-text-field
    v-model="text"
    flat
    variant="solo-filled"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :rounded="rounded"
    data-testid="text-field"
  >
    <template #append-inner>
      <slot name="append-inner" />
    </template>
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-text-field>
</template>

<style></style>
